import { FormInstance } from 'antd';
import React from 'react';

import { ComplianceItemV2Type } from '@onboarding/graphql';
import {
  WorksListItemLongTypesType,
  WorksListItemShortTypesType,
  worksListItemLongToShortTypeMap,
} from '@onboarding/services';
import { ComplianceItemUpdateFormAssessment } from './_compliance-item-update-form-assessment';
import { ComplianceItemUpdateFormCertification } from './_compliance-item-update-form-certification';
import { ComplianceItemUpdateFormHealthDoc } from './_compliance-item-update-form-health-doc';
import { ComplianceItemUpdateFormIdDoc } from './_compliance-item-update-form-id-doc';
import { ComplianceItemUpdateFormImmigration } from './_compliance-item-update-form-immigration';
import { ComplianceItemUpdateFormLicense } from './_compliance-item-update-form-license';
import { ComplianceItemUpdateFormOtherDoc } from './_compliance-item-update-form-other-doc';

type Props = {
  form: FormInstance;
  complianceItem: ComplianceItemV2Type;
  refetchQueries: string[];
  onDeleted?: () => void;
  onSubmit?: () => void;
  onSuccess?: () => void;
  onError?: () => void;
};

function getShortType(longType: WorksListItemLongTypesType | undefined) {
  return longType ? worksListItemLongToShortTypeMap[longType] : '';
}

export function ComplianceItemUpdateFormV2({
  form,
  complianceItem,
  refetchQueries,
  onSubmit,
  onDeleted,
  onSuccess,
  onError,
}: Props) {
  const formList = {
    assessment: ComplianceItemUpdateFormAssessment,
    certification: ComplianceItemUpdateFormCertification,
    health_doc: ComplianceItemUpdateFormHealthDoc,
    identification: ComplianceItemUpdateFormIdDoc,
    immigration: ComplianceItemUpdateFormImmigration,
    license: ComplianceItemUpdateFormLicense,
    other_doc: ComplianceItemUpdateFormOtherDoc,
  };

  const shortType = getShortType(complianceItem.type);
  const SpecificForm = formList[shortType as WorksListItemShortTypesType];

  return (
    <SpecificForm
      form={form}
      complianceItem={complianceItem}
      refetchQueries={refetchQueries}
      onSubmit={onSubmit}
      onDeleted={onDeleted}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
}
